module.exports = {"AT":"AUT","AU":"AUS","BE":"BEL","BR":"BRA","CA":"CAN","CH":"CHE","CL":"CHL","CZ":"CZE","DE":"DEU","DK":"DNK","EE":"EST","ES":"ESP","FI":"FIN","FR":"FRA","GB":"GBR","GR":"GRC","HU":"HUN","IE":"IRL","IL":"ISR","IS":"ISL","IT":"ITA","JP":"JPN","KR":"KOR","LU":"LUX","LV":"LVA","MX":"MEX","NL":"NLD","NO":"NOR","NZ":"NZL","PL":"POL","PT":"PRT","RU":"RUS","SE":"SWE","SI":"SVN","SK":"SVK","TR":"TUR","US":"USA","ZA":"ZAF"}


//////////////////
// WEBPACK FOOTER
// ./src/data/CountryCodes.json
// module id = 387
// module chunks = 0